
      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequirefc28"];
var parcelRegister = parcelRequire.register;
parcelRegister("2feYn", function(module, exports) {
/**
 * THIS FILE WAS CREATED VIA CODEGEN DO NOT MODIFY {@see http://go/af-codegen}
 * @codegen <<SignedSource::eaee527b5a9128134f2f3ecac1b0a289>>
 * @codegenCommand yarn build:icon-glyphs
 */ "use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.default = void 0;

var $1a2898c7452ddac4$var$_react = $1a2898c7452ddac4$var$_interopRequireDefault((parcelRequire("fc4bM")));

var $1a2898c7452ddac4$var$_iconNew = $1a2898c7452ddac4$var$_interopRequireDefault((parcelRequire("7ypK2")));
function $1a2898c7452ddac4$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        default: e
    };
}
/**
 * Icon: "InformationCircle".
 * Category: multi-purpose
 * Location: @atlaskit/icon/core/information-circle
 * Usage guidance:
 * Known uses: For highlighting information when less visual emphasis is needed within the UI compared to the filled information status icon.
 * - [Examples](https://atlaskit.atlassian.com/packages/design-system/icon)
 * - [Code](https://atlaskit.atlassian.com/packages/design-system/icon/docs/custom-icons)
 */ const $1a2898c7452ddac4$var$InformationCircleIcon = (props)=>/*#__PURE__*/ $1a2898c7452ddac4$var$_react.default.createElement($1a2898c7452ddac4$var$_iconNew.default, Object.assign({
        name: "InformationCircleIcon",
        dangerouslySetGlyph: `<path fill="currentcolor" fill-rule="evenodd" d="M8 1.5a6.5 6.5 0 1 0 0 13 6.5 6.5 0 0 0 0-13M0 8a8 8 0 1 1 16 0A8 8 0 0 1 0 8m7.25.25H6.5v-1.5H8a.75.75 0 0 1 .75.75v5h-1.5z" clip-rule="evenodd"/><path fill="currentcolor" d="M9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0"/>`
    }, props));
$1a2898c7452ddac4$var$InformationCircleIcon.displayName = 'InformationCircleIcon';
var $1a2898c7452ddac4$var$_default = module.exports.default = $1a2898c7452ddac4$var$InformationCircleIcon;

});


//# sourceMappingURL=information-circle.95c2504a.js.map
